import React from 'react'
import ClassEnroll from '../../../modules/Class/Enroll'

const ClassEnrollPage = () => {
  return <ClassEnroll />
}

export default ClassEnrollPage
